import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 border border-foreground-200/60 text-foreground-600 text-xs font-medium rounded-full mb-4">
            Updated 2026
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-2">
            Kakobuy Spreadsheet
          </h2>
          <p className="text-xl md:text-2xl font-heading text-secondary-600 mb-4">
            Polska Edition
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl">
            Przeglądaj wszystkie kategorie produktów dostępnych w{' '}
            <strong>Kakobuy Spreadsheet</strong>. Każda kategoria zawiera starannie wyselekcjonowane produkty z aktualnymi linkami i cenami.
          </p>
        </div>

        <div className="mb-10">
          <label htmlFor="category-select" className="block text-sm font-medium text-foreground-700 mb-2">
            Wybierz kategorię
          </label>
          <select
            id="category-select"
            value={selectedCategory}
            onChange={handleDropdownChange}
            className="w-full max-w-md px-4 py-3 bg-background-100 border-b-2 border-foreground-200 text-foreground-950 text-sm rounded-none focus:outline-none focus:border-primary-500 transition-colors cursor-pointer appearance-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23555' viewBox='0 0 16 16'%3E%3Cpath d='M4.646 5.646a.5.5 0 0 1 .708 0L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center',
              paddingRight: '40px',
            }}
          >
            <option value="">Wybierz kategorię</option>
            {categories.map((cat) => (
              <option key={cat.name} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 mb-8">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="aspect-square w-full overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3 text-center">
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-1 text-sm text-foreground-700 hover:text-foreground-950 underline underline-offset-4 transition-colors cursor-pointer"
        >
          Zobacz wszystkie produkty
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}